import type { ReactNode } from 'react';

export const symbol_glass_cup: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M262-80q-23 0-40.34-14.93Q204.31-109.86 202-133l-75-680q-3-27 14.84-47 17.83-20 45.16-20h586q27.33 0 45.16 20Q836-840 833-813l-75 680q-2.31 23.14-19.66 38.07Q721-80 698-80H262Zm-12-170 12 110h436l12-110H250Zm-7-61h474l56-509H187l56 509Zm7 171h460-460Z"
		/>
	</svg>
);
